<template>
  <v-container>
    <v-layout justify-center style="flex-wrap: wrap">
      <v-btn small @click="createConvenzione" color="primary">{{
        $t("create_convention")
      }}</v-btn>
    </v-layout>
    <DataTables @editConvenzione="editConvenzione" @viewConvenzione="viewConvenzione" @copyConvenzione="copyConvenzione"
      :headers="headers" :tableData="tableData"></DataTables>
    <edit-convenzione ref="gestConvenzioneDialog" @isUpdated="loadTable"></edit-convenzione>
  </v-container>
</template>

<script>
import gestConvenzione from "@/app/ente/gestConvenzione.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-convenzioni",
  components: {
    DataTables,
    "edit-convenzione": gestConvenzione,
  },
  data() {
    return {
      headers: [
        { text: this.$t("code"), value: "key" },
        { text: this.$t("description"), value: "text" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    viewConvenzione(item) {
      this.$refs.gestConvenzioneDialog.open("VIEW", item.key);
    },
    createConvenzione() {
      this.$refs.gestConvenzioneDialog.open("ADD", null);
    },
    editConvenzione(item) {
      this.$refs.gestConvenzioneDialog.open("EDIT", item.key);
    },
    copyConvenzione(item) {
      this.$refs.gestConvenzioneDialog.open("COPY", item.key);
    },

    loadTable() {
      let _ = this;
      let url = "/auth/ente/listConvenzioni";
      _.tableData = [];
      this.chiamataAxios("POST", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          item.options = [
            {
              icon: "mdi-magnify",
              color: "green",
              function: "viewConvenzione",
            },
            {
              icon: "mdi-pencil",
              color: "primary",
              function: "editConvenzione",
            },
            {
              icon: "mdi-content-copy",
              color: "primary",
              function: "copyConvenzione",
            },
          ];
          return item;
        });
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>